import React from 'react';

import { motion } from 'framer-motion';



const itemVariants = {

  hidden: { opacity: 0, y: 20 },

  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },

};



const Contact: React.FC = () => {

  return (

    <motion.div

      initial="hidden"

      whileInView="visible"

      viewport={{ once: true, amount: 0.3 }}

      variants={itemVariants}

      className="max-w-3xl mx-auto text-center py-24 md:py-32"

    >

      <h2 className="font-display text-5xl md:text-7xl font-bold text-[var(--color-foreground)] mb-6 tracking-tight">

        Let's Create

      </h2>

      <p className="text-lg text-[var(--color-muted)] mb-10 max-w-2xl mx-auto">

        Have an ambitious project in mind? I'm available for freelance work and collaborations. Let's connect and build something extraordinary.

      </p>

      <a

        href="mailto:tornadog911@gmail.com"

        className="font-display text-3xl md:text-4xl text-[var(--color-foreground)] hover:text-[var(--color-muted)] transition-colors duration-300 relative inline-block pb-2

                   after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[var(--color-foreground)]

                   after:transition-transform after:duration-300 after:ease-out after:origin-left after:scale-x-100

                   hover:after:scale-x-0 hover:after:origin-right"

      >

        tornadog911@gmail.com

      </a>

      <div className="mt-12 text-center">

        <a href="https://x.com/fanofaliens" target="_blank" rel="noopener noreferrer" className="text-sm text-[var(--color-muted)] hover:text-[var(--color-foreground)] transition-colors">

          You can also find me on 𝕏

        </a>

      </div>

    </motion.div>

  );

};



export default Contact;